import { render, staticRenderFns } from "./AllResearch.vue?vue&type=template&id=3f511898"
import script from "./AllResearch.vue?vue&type=script&lang=js"
export * from "./AllResearch.vue?vue&type=script&lang=js"
import style0 from "./AllResearch.vue?vue&type=style&index=0&id=3f511898&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports